import { AiemEventsRequest, AiemService_GetAiemEvents } from '@src/gen/aiem/aiem_pb';
import {
  AiUnitAlertingService_GetAIUnitAlertingData,
  AiUnitAlertingService_UpdateAIUnitAlertingData,
  GetAIUnitAlertingRequest,
  UpdateAIUnitAlertingRequest,
} from '@src/gen/aiUnitAlerting/aiUnitAlerting_pb';
import {
  AiUnitHourlyComponentRequest,
  AiUnitHourlyCummulativeRequest,
  AiUnitHourlyDateRangeRequest,
  AiUnitHourlyService_GetAiUnitHourlyDateRange,
  AiUnitHourlyService_GetAiUnitUsageForecast,
  AiUnitHourlyService_GetAiUnitUsageThreshold,
  AiUnitHourlyService_GetCustomAiUnitThresholds,
  AiUnitHourlyService_GetHourlyAiUnitComponentUsage,
  AiUnitHourlyService_GetHourlyAiUnitCummulativeUsage,
  AiUnitHourlyService_GetHourlyAiUnitSummary,
  AiUnitHourlyService_UpdateCustomAiUnitThresholds,
  AiUnitHourlySummaryRequest,
  AiUnitUsageForecastRequest,
  AiUnitUsageThresholdRequest,
  GetCustomAiUnitThresholdsRequest,
  UpdateCustomAiUnitThresholdsRequest,
} from '@src/gen/aiUnitHourly/aiUnitHourly_pb';
import {
  AiUnitMaxRequest,
  AiUnitMaxService_GetAiUnitMaxStats,
  AiUnitMaxService_GetHourlyAiUnitMaxConsumption,
  AiUnitMaxStatsRequest,
} from '@src/gen/aiUnitMax/aiUnitMax_pb';
import {
  AIUnitUsageByPodRequest,
  AiUnitWorkspaceService_GetAIUnitUsageByPod,
  AiUnitWorkspaceService_GetAIUnitWorkspaceUsage,
  AiUnitWorkspaceService_GetAvailableWorkspaces,
  AIUnitWorkspaceUsageRequest,
  AvailableWorkspacesRequest,
} from '@src/gen/aiUnitWorkspace/aiUnitWorkspace_pb';
import { AppEventService_GetAppEvents, AppEventsRequest } from '@src/gen/app_event/appEvent/appevent_pb';
import {
  InstanceEventService_GetInstanceEvents,
  InstanceEventsRequest,
} from '@src/gen/app_event/instanceEvent/instanceevent_pb';
import {
  CreateUserGroupsRequest,
  CustomGroupManagementService_CreateUserGroups,
  CustomGroupManagementService_GetCustomerManagedGroups,
  CustomGroupManagementService_RemoveUserGroups,
  GetCustomerManagedGroupsRequest,
  RemoveUserGroupsRequest,
} from '@src/gen/custom_group_management/custom_group_management_pb';
import {
  DaiConnectorConfigService_DeleteDaiConfigFiles,
  DaiConnectorConfigService_GetDaiConfigFileContent,
  DaiConnectorConfigService_ListDaiConfigFiles,
  DaiConnectorConfigService_UploadDaiConfigFile,
  DeleteDaiConfigFilesRequest,
  GetDaiConfigFileContentRequest,
  ListDaiConfigFilesRequest,
  UploadDaiConfigFileRequest,
} from '@src/gen/daiConnectorConfig/daiConnectorConfig_pb';
import {
  EnvIdRequest,
  GetResourceBlockConsentRequest,
  NatGwRequest,
  NatGwService_GetEnvId,
  NatGwService_GetNatGwIps,
  NatGwService_GetResourceBlockConsent,
  NatGwService_SetResourceBlockConsent,
  SetResourceBlockConsentRequest,
} from '@src/gen/environment_info/natgw_pb';
import {
  EscorerEventsRequest,
  EscorerService_GetDailyEscorerErrorAndDatapointsCounts,
  EscorerService_GetDailyEscorerLatencyCounts,
  EscorerService_GetEscorerErrorEvents,
  EscorerService_GetEscorerLatencyEvents,
} from '@src/gen/escorer/escorer_pb';
import {
  EgressDeleteRequest,
  EgressUpdateRequest,
  FwIpRequest,
  FWManagementService_DeleteEgressRules,
  FWManagementService_DeleteIngressRules,
  FWManagementService_GetFwIps,
  FWManagementService_GetFwPorts,
  FWManagementService_UpdateEgressRules,
  FWManagementService_UpdateIngressRules,
  FwPortRequest,
  IngressDeleteRequest,
  IngressUpdateRequest,
} from '@src/gen/fw_management/fw_management_pb';
import {
  GetGpteEventCountsRequest,
  GpteDailyTokensUsageRequest,
  GpteEventRequest,
  GpteLLMTokensUsageRequest,
  GpteTokenConsumptionStatsRequest,
  GpteUsageStatsRequest,
  GpteUserUsageRequest,
  H2oGpteService_GetDailyTokenUsage,
  H2oGpteService_GetGpteEventCounts,
  H2oGpteService_GetGpteEvents,
  H2oGpteService_GetGpteUsageStats,
  H2oGpteService_GetLLMTokenUsage,
  H2oGpteService_GetTokenConsumptionStats,
  H2oGpteService_GetUserUsageMetrics,
} from '@src/gen/h2ogpte/h2ogpte_pb';
import { GetSAMLConfigRequest, IdpManagementService_GetSAMLConfig } from '@src/gen/idp_management/idp_management_pb';
import {
  GaugeMetricDailyStatRequest,
  GaugeMetricEventsRequest,
  MlopsGaugeMetricService_GetGaugeMetricDailyStats,
  MlopsGaugeMetricService_GetMlopsGaugeMetricTotalCount,
} from '@src/gen/mlops/gauge_metric/gaugemetric_pb';
import {
  CreateTrustedRolesRequest,
  GetTrustedRolesRequest,
  RemoveTrustedRolesRequest,
  TrustedRolesService_CreateTrustedRoles,
  TrustedRolesService_GetTrustedRoles,
  TrustedRolesService_RemoveTrustedRoles,
} from '@src/gen/trusted_roles/trusted_roles_pb';
import {
  LoginEventsRequest,
  LoginService_GetLoginEvents,
  LoginService_GetLoginStatistics,
} from '@src/gen/user_login/userlogin_pb';
import {
  AddMemberRequest,
  GetAllowedDomainsRequest,
  GetMembersRequest,
  RemoveMemberRequest,
  ResendActivationEmailsRequest,
  SetAllowedDomainsRequest,
  UserManagementService_AddMembers,
  UserManagementService_GetAllowedDomains,
  UserManagementService_GetMembers,
  UserManagementService_RemoveMembers,
  UserManagementService_ResendActivationEmails,
  UserManagementService_SetAllowedDomains,
} from '@src/gen/user_management/user_management_pb';
import {
  UserJourneyAvailableUsersRequest,
  UserJourneyRequest,
  UserJourneyService_GetUserJourneyAvailableUsers,
  UserJourneyService_GetUserJourneyEvents,
  UserJourneyService_GetUserJourneyPlotData,
} from '@src/gen/userjourney/userjourney_pb';
import { fetchWrapRPC } from '@shared-legacy/services/appstore/api';

export class AdminCenterServiceImpl {
  private basePath: string;
  constructor(basePath?: string) {
    this.basePath = basePath || '';
  }

  public setBasePath = (path: string) => {
    this.basePath = path;
  };

  public async getNatGwPublicIps(req: NatGwRequest) {
    return await fetchWrapRPC(NatGwService_GetNatGwIps, { basePath: this.basePath })({ ...req });
  }

  public async getUserLoginEvents(req: LoginEventsRequest) {
    return await fetchWrapRPC(LoginService_GetLoginEvents, { basePath: this.basePath })({ ...req });
  }

  public async getUserLoginEventsStats(req: LoginEventsRequest) {
    return await fetchWrapRPC(LoginService_GetLoginStatistics, { basePath: this.basePath })({ ...req });
  }

  public async getAIEMEvents(req: AiemEventsRequest) {
    return await fetchWrapRPC(AiemService_GetAiemEvents, { basePath: this.basePath })({ ...req });
  }

  public async getAppEvents(req: AppEventsRequest) {
    return await fetchWrapRPC(AppEventService_GetAppEvents, { basePath: this.basePath })({ ...req });
  }

  public async getInstanceEvents(req: InstanceEventsRequest) {
    return await fetchWrapRPC(InstanceEventService_GetInstanceEvents, { basePath: this.basePath })({ ...req });
  }

  public async getAiUnitMaxConsumption(req: AiUnitMaxRequest) {
    return await fetchWrapRPC(AiUnitMaxService_GetHourlyAiUnitMaxConsumption, { basePath: this.basePath })({ ...req });
  }

  public async getAiUnitMaxStats(req: AiUnitMaxStatsRequest) {
    return await fetchWrapRPC(AiUnitMaxService_GetAiUnitMaxStats, { basePath: this.basePath })({ ...req });
  }

  public async getMlopsGaugeMetrics(req: GaugeMetricEventsRequest) {
    return await fetchWrapRPC(MlopsGaugeMetricService_GetMlopsGaugeMetricTotalCount, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getMlopsGaugeDailyMetrics(req: GaugeMetricDailyStatRequest) {
    return await fetchWrapRPC(MlopsGaugeMetricService_GetGaugeMetricDailyStats, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getHourlyAiUnitCummulativeUsage(req: AiUnitHourlyCummulativeRequest) {
    return await fetchWrapRPC(AiUnitHourlyService_GetHourlyAiUnitCummulativeUsage, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getAiUnitUsageForecast(req: AiUnitUsageForecastRequest) {
    return await fetchWrapRPC(AiUnitHourlyService_GetAiUnitUsageForecast, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getAiUnitHourlyDateRange(req: AiUnitHourlyDateRangeRequest) {
    return await fetchWrapRPC(AiUnitHourlyService_GetAiUnitHourlyDateRange, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getAiUsageThresholds(req: AiUnitUsageThresholdRequest) {
    return await fetchWrapRPC(AiUnitHourlyService_GetAiUnitUsageThreshold, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getHourlyAiUnitComponentUsage(req: AiUnitHourlyComponentRequest) {
    return await fetchWrapRPC(AiUnitHourlyService_GetHourlyAiUnitComponentUsage, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getHourlyAiUnitSummary(req: AiUnitHourlySummaryRequest) {
    return await fetchWrapRPC(AiUnitHourlyService_GetHourlyAiUnitSummary, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getCustomAiUnitThresholds(req: GetCustomAiUnitThresholdsRequest) {
    return await fetchWrapRPC(AiUnitHourlyService_GetCustomAiUnitThresholds, { basePath: this.basePath })({
      ...req,
    });
  }

  public async updateCustomAiUnitThresholds(req: UpdateCustomAiUnitThresholdsRequest) {
    return await fetchWrapRPC(AiUnitHourlyService_UpdateCustomAiUnitThresholds, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getFwIps(req: FwIpRequest) {
    return await fetchWrapRPC(FWManagementService_GetFwIps, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getFwPorts(req: FwPortRequest) {
    return await fetchWrapRPC(FWManagementService_GetFwPorts, { basePath: this.basePath })({
      ...req,
    });
  }

  public async updateIngressRules(req: IngressUpdateRequest) {
    return await fetchWrapRPC(FWManagementService_UpdateIngressRules, { basePath: this.basePath })({
      ...req,
    });
  }

  public async updateEgressRules(req: EgressUpdateRequest) {
    return await fetchWrapRPC(FWManagementService_UpdateEgressRules, { basePath: this.basePath })({
      ...req,
    });
  }

  public async deleteIngressRules(req: IngressDeleteRequest) {
    return await fetchWrapRPC(FWManagementService_DeleteIngressRules, { basePath: this.basePath })({
      ...req,
    });
  }

  public async deleteEgressRules(req: EgressDeleteRequest) {
    return await fetchWrapRPC(FWManagementService_DeleteEgressRules, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getMembers(req: GetMembersRequest) {
    return await fetchWrapRPC(UserManagementService_GetMembers, { basePath: this.basePath })({
      ...req,
    });
  }

  public async addMembers(req: AddMemberRequest) {
    return await fetchWrapRPC(UserManagementService_AddMembers, { basePath: this.basePath })({
      ...req,
    });
  }

  public async removeMembers(req: RemoveMemberRequest) {
    return await fetchWrapRPC(UserManagementService_RemoveMembers, { basePath: this.basePath })({
      ...req,
    });
  }

  public async updateAIUnitAlertingData(req: UpdateAIUnitAlertingRequest) {
    return await fetchWrapRPC(AiUnitAlertingService_UpdateAIUnitAlertingData, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getAIUnitAlertingData(req: GetAIUnitAlertingRequest) {
    return await fetchWrapRPC(AiUnitAlertingService_GetAIUnitAlertingData, { basePath: this.basePath })({
      ...req,
    });
  }

  public async resendActivationEmail(req: ResendActivationEmailsRequest) {
    return await fetchWrapRPC(UserManagementService_ResendActivationEmails, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getAllowedDomains(req: GetAllowedDomainsRequest) {
    return await fetchWrapRPC(UserManagementService_GetAllowedDomains, { basePath: this.basePath })({
      ...req,
    });
  }

  public async setAllowedDomains(req: SetAllowedDomainsRequest) {
    return await fetchWrapRPC(UserManagementService_SetAllowedDomains, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getSAMLConfigRequest(req: GetSAMLConfigRequest) {
    return await fetchWrapRPC(IdpManagementService_GetSAMLConfig, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getCustomerManagedGroupsRequest(req: GetCustomerManagedGroupsRequest) {
    return await fetchWrapRPC(CustomGroupManagementService_GetCustomerManagedGroups, { basePath: this.basePath })({
      ...req,
    });
  }

  public async createUserGroupsRequest(req: CreateUserGroupsRequest) {
    return await fetchWrapRPC(CustomGroupManagementService_CreateUserGroups, { basePath: this.basePath })({
      ...req,
    });
  }

  public async removeUserGroupsRequest(req: RemoveUserGroupsRequest) {
    return await fetchWrapRPC(CustomGroupManagementService_RemoveUserGroups, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getEnvId(req: EnvIdRequest) {
    return await fetchWrapRPC(NatGwService_GetEnvId, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getResourceBlockConsent(req: GetResourceBlockConsentRequest) {
    return await fetchWrapRPC(NatGwService_GetResourceBlockConsent, { basePath: this.basePath })({
      ...req,
    });
  }

  public async setResourceBlockConsent(req: SetResourceBlockConsentRequest) {
    return await fetchWrapRPC(NatGwService_SetResourceBlockConsent, { basePath: this.basePath })({
      ...req,
    });
  }

  public async uploadDaiConfigFile(req: UploadDaiConfigFileRequest) {
    return await fetchWrapRPC(DaiConnectorConfigService_UploadDaiConfigFile, { basePath: this.basePath })({
      ...req,
    });
  }

  public async listDaiConfigFiles(req: ListDaiConfigFilesRequest) {
    return await fetchWrapRPC(DaiConnectorConfigService_ListDaiConfigFiles, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getDaiConfigFileContent(req: GetDaiConfigFileContentRequest) {
    return await fetchWrapRPC(DaiConnectorConfigService_GetDaiConfigFileContent, { basePath: this.basePath })({
      ...req,
    });
  }

  public async deleteDaiConfigFiles(req: DeleteDaiConfigFilesRequest) {
    return await fetchWrapRPC(DaiConnectorConfigService_DeleteDaiConfigFiles, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getGpteEvents(req: GpteEventRequest) {
    return await fetchWrapRPC(H2oGpteService_GetGpteEvents, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getGpteUsageStats(req: GpteUsageStatsRequest) {
    return await fetchWrapRPC(H2oGpteService_GetGpteUsageStats, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getGpteEventCounts(req: GetGpteEventCountsRequest) {
    return await fetchWrapRPC(H2oGpteService_GetGpteEventCounts, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getLLMTokenUsage(req: GpteLLMTokensUsageRequest) {
    return await fetchWrapRPC(H2oGpteService_GetLLMTokenUsage, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getDailyTokenUsage(req: GpteDailyTokensUsageRequest) {
    return await fetchWrapRPC(H2oGpteService_GetDailyTokenUsage, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getTokenConsumptionStats(req: GpteTokenConsumptionStatsRequest) {
    return await fetchWrapRPC(H2oGpteService_GetTokenConsumptionStats, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getUserUsageMetrics(req: GpteUserUsageRequest) {
    return await fetchWrapRPC(H2oGpteService_GetUserUsageMetrics, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getAiUnitUsageByPodRequest(req: AIUnitUsageByPodRequest) {
    return await fetchWrapRPC(AiUnitWorkspaceService_GetAIUnitUsageByPod, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getAvailableWorkspacesRequest(req: AvailableWorkspacesRequest) {
    return await fetchWrapRPC(AiUnitWorkspaceService_GetAvailableWorkspaces, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getAiUnitWorkspaceUsageRequest(req: AIUnitWorkspaceUsageRequest) {
    return await fetchWrapRPC(AiUnitWorkspaceService_GetAIUnitWorkspaceUsage, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getTrustedRolesRequest(req: GetTrustedRolesRequest) {
    return await fetchWrapRPC(TrustedRolesService_GetTrustedRoles, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getEscorerLatencyEvents(req: EscorerEventsRequest) {
    return await fetchWrapRPC(EscorerService_GetEscorerLatencyEvents, { basePath: this.basePath })({
      ...req,
    });
  }

  public async createTrustedRolesRequest(req: CreateTrustedRolesRequest) {
    return await fetchWrapRPC(TrustedRolesService_CreateTrustedRoles, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getEscorerErrorEvents(req: EscorerEventsRequest) {
    return await fetchWrapRPC(EscorerService_GetEscorerErrorEvents, { basePath: this.basePath })({
      ...req,
    });
  }

  public async removeTrustedRolesRequest(req: RemoveTrustedRolesRequest) {
    return await fetchWrapRPC(TrustedRolesService_RemoveTrustedRoles, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getDailyEscorerLatencyCounts(req: EscorerEventsRequest) {
    return await fetchWrapRPC(EscorerService_GetDailyEscorerLatencyCounts, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getDailyEscorerErrorAndDatapointsCounts(req: EscorerEventsRequest) {
    return await fetchWrapRPC(EscorerService_GetDailyEscorerErrorAndDatapointsCounts, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getUserJourneyEvents(req: UserJourneyRequest) {
    return await fetchWrapRPC(UserJourneyService_GetUserJourneyEvents, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getUserJourneyPlotData(req: UserJourneyRequest) {
    return await fetchWrapRPC(UserJourneyService_GetUserJourneyPlotData, { basePath: this.basePath })({
      ...req,
    });
  }

  public async getUserJourneyAvailableUsers(req: UserJourneyAvailableUsersRequest) {
    return await fetchWrapRPC(UserJourneyService_GetUserJourneyAvailableUsers, { basePath: this.basePath })({
      ...req,
    });
  }
}
